import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { AppHeader } from "@/components/AppHeader";
import { MouseFollowRefraction } from "@/components/MouseFollowRefraction";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <a href="#main-content" className="skip-to-main">Перейти к содержимому</a>
        <AppSidebar />
        <div className="flex flex-1 flex-col">
          <AppHeader />
           <main id="main-content" className="mesh-bg relative flex-1 overflow-auto p-3 sm:p-6" role="main">
             <MouseFollowRefraction />
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              className="relative z-10"
            >
              {children}
            </motion.div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
